import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { Router, RouterOutlet, RoutesRecognized } from '@angular/router';
import { Store } from '@ngrx/store';
import { Duration } from 'luxon';
import { filter, pairwise } from 'rxjs/operators';

import { AppService } from './app.service';
import { CastService } from './cast/services/cast-service';
import { NomWebServicesJson } from './common/services/nom-web-services-json';
import { selectJWTToken } from './common/store/navigation/selectors/application.selectors';
import { formatDurationLikeMoment } from './common/utils/date-utils';
import { DiscoverSearchService } from './discover/services/discover-search-service';
import { DiscoverService } from './discover/services/discover-service';
import { PlaybookService } from './playbook/services/playbook-service';

@Component({
    selector: 'st-app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-app-component',
    },
})
export class AppComponent {
    private router = inject(Router);
    private appService = inject(AppService);
    playbookService = inject(PlaybookService);
    castService = inject(CastService);
    discoverService = inject(DiscoverService);
    discoverSearchService = inject(DiscoverSearchService);
    private nomWebServicesJson = inject(NomWebServicesJson);
    private store = inject(Store);

    readonly token = this.store.selectSignal(selectJWTToken);

    constructor() {
        // Left for reference
        // moment.duration.fn.toString = function () {
        //     return this.format('d.h:mm:ss', { stopTrim: 'mm', forceLength: true });
        // };
        Duration.prototype.toString = function () {
            return formatDurationLikeMoment(this);
        };
        this.router.events
            .pipe(
                filter((e: any) => e instanceof RoutesRecognized),
                pairwise()
            )
            .subscribe((e: any) => {
                localStorage.setItem('prevUrl', e[1].urlAfterRedirects);
                this.appService.previousUrl = e[1].urlAfterRedirects;
            });

        const registerServiceWorker = () => {
            navigator.serviceWorker
                .register('./img-service-service.js')
                .then(() => {
                    return navigator.serviceWorker.ready;
                })
                .then(reg => {
                    this.nomWebServicesJson.imgServiceWorker = reg.active;
                    this.nomWebServicesJson?.imgServiceWorker?.postMessage({ authorization: this.token() });
                })
                .catch(error => {
                    console.warn('Error : ', error);
                });
        };
        if (!navigator?.serviceWorker?.controller) {
            navigator?.serviceWorker?.getRegistrations()?.then(registrations => {
                Promise.all(registrations?.map(r => r.unregister())).then(() => {
                    registerServiceWorker();
                });
            });
        } else {
            registerServiceWorker();
        }
    }
}
